import React from "react";
import LoadingSpinner from "./LoadingSpinner";

export default function PageLoader() {
  return <LoadingSpinner fullscreen centered size={80} color="var(--primaryAccent)" />
}